(ns frontend.view.components.pie-chart
  (:require
   [frontend.utils :as fu]))

(defn options
  [{:keys [height width size label label-color start-angle end-angle custom-colors label-distance
           inner-size]} items]
  {:chart       {:type         "pie"
                 :borderColor  "lightgray"
                 :borderRadius 10
                 :borderWidth  0
                 :plotShadow   false
                 :height       height
                 :width        width}
   :title       {:text  label
                 :style (merge {}
                               (when label-color
                                 {:color (fu/sanitize-color label-color)}))}
   :series      [{:data      items
                  :innerSize (or inner-size "40%")
                  :animation false}]
   :plotOptions {:pie (merge {:dataLabels   {:enabled  true
                                             :distance (or label-distance -50)
                                             :style    {:fontWeight "bold"
                                                        :color      "white"}
                                             :format   "{y}"}
                              :size         size
                              :startAngle   (or start-angle -180)
                              :endAngle     (or end-angle 180)
                              :center       ["50%" "50%"]
                              :showInLegend true}
                             (when custom-colors
                               {:colors (->> custom-colors
                                             (map fu/sanitize-color)
                                             (doall))}))}
   :tooltip     {:enabled false}
   :credits     {:enabled false}
   :legend      {:enabled true}})
